import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button, Card, CardGroup, Col, Container, Row } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { filteredItemByArray } from "../../../utils/ManageArray";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { FloatingControlComponent } from "../../../components/FormComponent";
import SearchFilter from "../../../components/SearchFilter";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import CustomersService from "../../../services/customer.service";

export default function CustomerInformation() {
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState({});
  const searchInput = [
    {
      name: "Cus_Code",
      label: "รหัสสาขา (ลูกค้า)",
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setData(items)
        })
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า",
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setData(items)
        })
    }
  ];
  const infoField = [
    {
      label: "ข้อมูลลูกค้า/สาขา",
      field: [
        { name: "Cus_Code", label: "ข้อมูลลูกค้า/สาขา" },
        { name: "Cus_NumBranch", label: "เลขสาขา" },
        { name: "Cus_Ref", label: "รหัสลูกค้าอ้างอิง" },
        { name: "Cus_Name", label: "ชื่อลูกค้า" },
        { name: "Cus_Group", label: "กลุ่มลูกค้า" },
        { name: "Cus_Type", label: "ประเภทลูกค้า" },
        { name: "Cus_Tel1", label: "เบอร์โทร 1" },
        { name: "Cus_Tel2", label: "เบอร์โทร 2" },
        { name: "Cus_Fax", label: "เบอร์แฟกซ์" },
        { name: "Cus_Admin1", label: "Admin Brand 1" },
        { name: "Cus_Admin2", label: "Admin Brand 2" },
        { name: "Com_Status", label: "สถานะ" }
      ]
    },
    {
      label: "ข้อมูลผู้ติดต่อ",
      field: [
        { name: "Cus_ContactName", label: "ชื่อ" },
        { name: "Cus_ContactTel", label: "เบอร์โทร" },
        { name: "Cus_ContactMobile", label: "เบอร์มือถือ" },
        { name: "Cus_ContactFax", label: "เบอร์แฟกซ์" },
        { name: "Cus_ContactEmail", label: "อีเมล" }
      ]
    },
    {
      label: "รายละเอียดที่อยู่",
      field: [
        { name: "Cus_Address", label: "ที่อยู่", size: 6 },
        { name: "Cus_Road", label: "ถนน" },
        { name: "Cus_SubDistrict", label: "ตำบล/แขวง" },
        { name: "Cus_District", label: "อำเภอ/เขต" },
        { name: "Cus_Province", label: "จังหวัด" },
        { name: "Cus_ZipCode", label: "รหัสไปรษณีย์" },
        { name: "Cus_Zone", label: "โซน" },
        { name: "Cus_Coordinates", label: "พิกัด" }
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>ข้อมูลลูกค้า</title>
        <meta name="description" content="Customer Information Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          body={{
            element: (
              <SearchFilter
                data={data}
                inputField={searchInput}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(search) =>
                  setFilteredData(
                    search.some(({ value }) => value)
                      ? filteredItemByArray(data, search)?.[0]
                      : {}
                  )
                }
              />
            )
          }}
        />

        <CardDisplayComponent
          header={{
            className: "pb-0 text-end",
            button: (
              <Button
                variant="success"
                className="px-5 pt-2 text-dark rounded-pill"
              >
                อัพโหลดข้อมูล
              </Button>
            )
          }}
          body={{
            className: "p-0",
            element: infoField.map(({ label, field }, index) => {
              return (
                <CardGroup key={index} className="p-3 pt-0 flex-column">
                  <Card.Header className="mb-4 p-0 pb-2  bg-transparent">
                    <Card.Title className=" fs-2 text-dark">{label}</Card.Title>
                  </Card.Header>

                  <Card.Body className="p-0">
                    <Row>
                      {field.map(({ label, name, size }, idx) => {
                        return (
                          <Col
                            key={`${index}-${idx}`}
                            sm={size || 3}
                            className={`mt-1 ${idx !== 7 ? "mb-3" : ""} fs-4`}
                          >
                            <FloatingControlComponent
                              readOnly
                              type="text"
                              name={name}
                              label={label}
                              value={filteredData?.[name] || "-"}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Card.Body>
                </CardGroup>
              );
            })
          }}
        />
      </Container>
    </>
  );
}
